import { Bold } from './bold.jsx'

export * from './bold.jsx'

export default Bold
